import { Component } from '@/core/Component';
import { createElement } from '@/utils/dom';

export class ScrollProgress extends Component {
  constructor() {
    super();
  }

  protected requiresElement(): boolean {
    return false; // We create our own element
  }

  protected mount(): void {
    // Create the progress bar element
    const progressBar = createElement(
      'div',
      'fixed top-0 left-0 h-1 bg-gradient-to-r from-blue-500 to-purple-500 z-[60] transition-all duration-100 ease-out'
    );
    progressBar.style.width = '0%';
    document.body.appendChild(progressBar);
    this.element = progressBar;

    window.addEventListener(
      'scroll',
      () => {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        const scrollHeight =
          document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const scrollPercent = (scrollTop / scrollHeight) * 100;
        progressBar.style.width = `${scrollPercent}%`;
      },
      { passive: true }
    );
  }
}
